// extracted by mini-css-extract-plugin
export var activeIndex = "LandingFooter-module--activeIndex--9549b";
export var cMarginTop = "LandingFooter-module--c-margin-top--c0226";
export var cPadding = "LandingFooter-module--c-padding--20c16";
export var cPaddingBottom = "LandingFooter-module--c-padding-bottom--ae20c";
export var cPaddingTop = "LandingFooter-module--c-padding-top--cae53";
export var col1 = "LandingFooter-module--col1--473be";
export var content = "LandingFooter-module--content--0ee31";
export var copyrightText = "LandingFooter-module--copyrightText--38918";
export var date = "LandingFooter-module--date--ed41d";
export var disabled = "LandingFooter-module--disabled--05b09";
export var ellipsis = "LandingFooter-module--ellipsis--a3006";
export var featuredSection = "LandingFooter-module--featuredSection--9bd54";
export var footerContainer = "LandingFooter-module--footerContainer--96df6";
export var footerLogo = "LandingFooter-module--footerLogo--af5ab";
export var footerMenu = "LandingFooter-module--footerMenu--6b94c";
export var globalSpacing = "LandingFooter-module--global-spacing--98910";
export var globalSpacingBottom = "LandingFooter-module--global-spacing-bottom--291a7";
export var globalSpacingTop = "LandingFooter-module--global-spacing-top--1e9ff";
export var image = "LandingFooter-module--image--5ee49";
export var imageWrapper = "LandingFooter-module--imageWrapper--2e5e2";
export var index = "LandingFooter-module--index--ecb0d";
export var listItem = "LandingFooter-module--listItem--4a5cf";
export var maxWidth = "LandingFooter-module--max-width--6aedb";
export var navButton = "LandingFooter-module--navButton--f9a40";
export var pagination = "LandingFooter-module--pagination--dbfca";
export var para = "LandingFooter-module--para--e108e";
export var paraSection = "LandingFooter-module--paraSection--d50dd";
export var styleTick = "LandingFooter-module--styleTick--11af6";
export var tag = "LandingFooter-module--tag--99377";
export var tagWrapper = "LandingFooter-module--tagWrapper--373b2";
export var title = "LandingFooter-module--title--5c198";
export var whatsappWrapper = "LandingFooter-module--whatsappWrapper--a5f7b";